import Layout from "@/page/index/";
export default [
  {
    path: "/salesCloud",
    component: Layout,
    children: [
      {
        path: "department",
        name: "部门管理",
        component: () =>
          import("@/views/salesCloud/enterpriseSupervise/department/index"),
      },
      {
        path: "position",
        name: "职位管理",
        component: () =>
          import("@/views/salesCloud/enterpriseSupervise/position/index"),
      },
      {
        path: "stuff",
        name: "员工管理",
        component: () =>
          import("@/views/salesCloud/enterpriseSupervise/stuff/index"),
      },
      {
        path: "stuff/add",
        name: "新增员工",
        component: () =>
          import("@/views/salesCloud/enterpriseSupervise/stuff/add"),
      },
      {
        path: "stuff/edit",
        name: "员工信息",
        component: () =>
          import("@/views/salesCloud/enterpriseSupervise/stuff/edit"),
      },
      {
        path: "notice",
        name: "公告管理",
        component: () =>
          import("@/views/salesCloud/enterpriseSupervise/notice/index"),
      },
      {
        path: "depRule",
        name: "部门积分规则管理",
        component: () =>
          import("@/views/salesCloud/enterpriseSupervise/depRule/index"),
      },
      {
        path: "stuffRule",
        name: "员工积分规则管理",
        component: () =>
          import("@/views/salesCloud/enterpriseSupervise/stuffRule/index"),
      },
      {
        path: "menu",
        name: "菜单管理",
        component: () => import("@/views/salesCloud/menu/index"),
      },
      {
        path: "agent",
        name: "代理商管理",
        component: () =>
          import("@/views/salesCloud/agentSupervise/agent/index"),
      },
      {
        path: "releaseSale",
        name: "发布分销",
        component: () =>
          import("@/views/salesCloud/zstSaleSupervise/releaseSale/index"),
      },
      {
        path: "settlement",
        name: "结算管理",
        component: () =>
          import("@/views/salesCloud/zstSaleSupervise/settlement/index"),
      },
      {
        path: "promotersStatistics",
        name: "推广员分销统计",
        component: () =>
          import(
            "@/views/salesCloud/zstSaleSupervise/promotersStatistics/index"
          ),
      },
      {
        path: "promotersStatistics/:id",
        name: "推广员分销统计详情",
        component: () =>
          import(
            "@/views/salesCloud/zstSaleSupervise/promotersStatistics/detail"
          ),
      },
      {
        path: "saleView",
        name: "分销数据概览",
        component: () =>
          import("@/views/salesCloud/zstSaleSupervise/saleView/index"),
      },
      {
        path: "zxtecharts",
        name: "折线图",
        component: () =>
          import("@/views/salesCloud/zstSaleSupervise/saleView/echarts"),
      },
      {
        path: "bindEngineer",
        name: "工程师管理",
        component: () =>
          import("@/views/salesCloud/usersSupervise/bindEngineer/index"),
      },
      {
        path: "bindPromoters",
        name: "推广员管理",
        component: () =>
          import("@/views/salesCloud/usersSupervise/bindPromoters/index"),
      },
      // 推广员报名
      {
        path: "promotersApply",
        name: "推广员报名",
        component: () =>
          import("@/views/salesCloud/usersSupervise/promotersApply/index"),
      },
      {
        path: "warehouse",
        name: "前仓管理",
        component: () => import("@/views/salesCloud/warehouse/index"),
      },
      {
        path: "decorator",
        name: "装饰公司管理",
        component: () => import("@/views/salesCloud/decorator/index"),
      },
      {
        path: "region",
        name: "区域管理",
        component: () => import("@/views/salesCloud/region/index"),
      },
      {
        path: "warehouse/goosDetailsView",
        name: "前仓商品明细",
        component: () => import("@/views/salesCloud/warehouse/goosDetailsView"),
      },
      {
        path: "warehouse/view",
        name: "前仓详情",
        component: () => import("@/views/salesCloud/warehouse/view"),
      },
      {
        path: "warehouse/detailEntry",
        name: "前仓库存详情",
        component: () => import("@/views/salesCloud/warehouse/detailEntry"),
      },
      {
        path: "engineerLeader",
        name: "工程监理管理",
        component: () =>
          import("@/views/salesCloud/usersSupervise/engineerLeader/index"),
      },
      {
        path: "tags",
        name: "标签管理",
        component: () =>
          import("@/views/salesCloud/userTagsSupervise/tags/index"),
      },
      {
        path: "commerceGoods",
        name: "商品管理",
        component: () =>
          import("@/views/salesCloud/commerceSupervise/commerceGoods/index"),
      },
      {
        path: "engineerClassify",
        name: "建材采购分类",
        component: () =>
          import("@/views/salesCloud/commerceSupervise/engineerClassify/index"),
      },
      {
        path: "engineerGoods",
        name: "工程师/监理商品列表",
        component: () =>
          import("@/views/salesCloud/commerceSupervise/engineerGoods/index"),
      },
      {
        path: "engineerOrder",
        name: "建材采购订单列表",
        component: () =>
          import("@/views/salesCloud/commerceSupervise/engineerOrder/index"),
      },
      {
        path: "commerceGoodsSale",
        name: "商品售卖管理",
        component: () =>
          import(
            "@/views/salesCloud/commerceSupervise/commerceGoodsSale/index"
          ),
      },
      {
        path: "commerceGoodsReturn",
        name: "订单退货管理",
        component: () =>
          import(
            "@/views/salesCloud/commerceSupervise/commerceGoodsReturn/index"
          ),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "engineerSale",
        name: "工程师售卖管理",
        component: () =>
          import("@/views/salesCloud/commerceSupervise/engineerSale/index"),
      },
      {
        path: "engineerSaleOrder",
        name: "工程师售卖订单管理",
        component: () =>
          import(
            "@/views/salesCloud/commerceSupervise/engineerSaleOrder/index"
          ),
      },
      {
        path: "engineerOrderDetails",
        name: "工程师售卖产品订单明细",
        component: () =>
          import(
            "@/views/salesCloud/commerceSupervise/engineerOrderDetails/index"
          ),
      },
      {
        path: "groupPurchase",
        name: "商品团购",
        component: () =>
          import("@/views/salesCloud/commerceSupervise/groupPurchase/index"),
      },
      {
        path: "groupPurchase/:id",
        name: "商品团购明细",
        component: () =>
          import("@/views/salesCloud/commerceSupervise/groupPurchase/detail"),
      },
      {
        path: "seckill",
        name: "限时秒杀",
        component: () =>
          import("@/views/salesCloud/commerceSupervise/seckill/index"),
      },
      {
        path: "setTags",
        name: "设置标签",
        component: () =>
          import("@/views/salesCloud/userTagsSupervise/setTags/index"),
      },
      {
        path: "mobileRedPacket",
        name: "发手机红包",
        component: () => import("@/views/salesCloud/mobileRedPacket/index"),
      },
      {
        path: "mobileRedPacket/detail/:id",
        name: "领取详情",
        component: () => import("@/views/salesCloud/mobileRedPacket/detail"),
      },
      {
        path: "remittanceAudit",
        name: "汇款审核管理",
        component: () => import("@/views/salesCloud/remittanceAudit/index"),
      },
      {
        path: "projectProgress",
        name: "工程进度管理",
        component: () =>
          import("@/views/salesCloud/customerSupervise/projectProgress/index"),
      },
      {
        path: "customerClassify",
        name: "系统类别管理",
        component: () =>
          import("@/views/salesCloud/customerSupervise/customerClassify/index"),
      },
      {
        path: "addMoney",
        name: "添加钱包金额",
        component: () =>
          import("@/views/salesCloud/walletSupervise/addMoney/index"),
      },
      {
        path: "warehousing",
        name: "入库管理",
        component: () =>
          import("@/views/salesCloud/stockSupervise/warehousing/index"),
      },
      {
        path: "warehousing/add",
        name: "新增入库",
        component: () =>
          import("@/views/salesCloud/stockSupervise/warehousing/add"),
      },
      {
        path: "warehousing/Edit",
        name: "修改入库信息",
        component: () =>
          import("@/views/salesCloud/stockSupervise/warehousing/add"),
      },
      {
        path: "warehousing/log/:id",
        name: "商品入库记录",
        component: () =>
          import("@/views/salesCloud/stockSupervise/warehousing/log"),
      },
      {
        path: "stockRemoval",
        name: "出库管理",
        component: () =>
          import("@/views/salesCloud/stockSupervise/stockRemoval/index"),
      },
      {
        path: "shipmentManagement",
        name: "出货管理",
        component: () =>
          import("@/views/salesCloud/stockSupervise/shipment/index"),
      },
      {
        path: "shipmentManagement/add",
        name: "新增出货",
        component: () =>
          import("@/views/salesCloud/stockSupervise/shipment/add"),
      },
      {
        path: "productSku",
        name: "SKU组合管理",
        component: () =>
          import("@/views/salesCloud/stockSupervise/productSku/index"),
      },
      {
        path: "classify",
        name: "分类管理",
        component: () => import("@/views/salesCloud/classify/index"),
      },
      {
        path: "shipmentManagement/view",
        name: "查看出货详情",
        component: () =>
          import("@/views/salesCloud/stockSupervise/shipment/view"),
      },
      {
        path: "agentOrderManagement",
        name: "订单管理",
        component: () =>
          import(
            "@/views/salesCloud/stockSupervise/agentOrderManagement/index"
          ),
      },
      {
        // 代理商订单详情
        path: "agentOrderManagement/view",
        name: "订单详情",
        component: () =>
          import("@/views/salesCloud/stockSupervise/agentOrderManagement/view"),
      },
      {
        path: "refund",
        name: "采购退货管理",
        component: () =>
          import("@/views/salesCloud/stockSupervise/refund/index"),
      },
      {
        path: "refundForm/:id",
        name: "采购退货单",
        component: () =>
          import("@/views/salesCloud/stockSupervise/refundForm/index"),
      },
      {
        path: "stockForm/:id",
        name: "采购出库单",
        component: () =>
          import("@/views/salesCloud/stockSupervise/stockForm/index"),
      },
      {
        path: "stockMonitor",
        name: "商户库存云监控",
        component: () =>
          import("@/views/salesCloud/stockSupervise/stockMonitor/index"),
      },
      {
        path: "stockMonitor/detail/:id",
        name: "商户库存详情",
        component: () =>
          import("@/views/salesCloud/stockSupervise/stockMonitor/detail"),
      },
      {
        path: "purchase",
        name: "商户采购权限管理",
        component: () =>
          import("@/views/salesCloud/financeSupervise/purchase/index"),
      },
      {
        path: "credit",
        name: "商户信用管理",
        component: () =>
          import("@/views/salesCloud/financeSupervise/credit/index"),
      },
      {
        path: "payment",
        name: "应付款管理",
        component: () =>
          import("@/views/salesCloud/financeSupervise/payment/index"),
      },
      {
        path: "payment/detail/:id",
        name: "应付款详情",
        component: () =>
          import("@/views/salesCloud/financeSupervise/payment/detail"),
      },
      {
        path: "ar",
        name: "应收款管理",
        component: () => import("@/views/salesCloud/financeSupervise/ar/index"),
      },
      {
        path: "ar/detail/:id",
        name: "应收款详情",
        component: () =>
          import("@/views/salesCloud/financeSupervise/ar/detail"),
      },

      {
        path: "videos",
        name: "短视频管理",
        component: () => import("@/views/salesCloud/videoSupervise/videos"),
      },
      {
        path: "financial",
        name: "财务报表",
        component: () =>
          import("@/views/salesCloud/financeSupervise/financial"),
      },
      {
        path: "financial/echarts",
        name: "饼图",
        component: () =>
          import("@/views/salesCloud/financeSupervise/financial/echarts"),
      },
      {
        path: "pointsRule",
        name: "积分奖惩制度管理",
        component: () =>
          import("@/views/salesCloud/enterpriseSupervise/pointsRule/index"),
      },
      {
        path: "points",
        name: "积分制管理",
        component: () =>
          import("@/views/salesCloud/enterpriseSupervise/points/index"),
      },
      {
        path: "pointsDetails",
        name: "积分明细管理",
        component: () =>
          import("@/views/salesCloud/enterpriseSupervise/pointsDetail/index"),
      },
      {
        path: "shop",
        name: "商户店铺管理",
        component: () => import("@/views/salesCloud/usersSupervise/shop/index"),
      },
      // /salesCloud/managingStaff  管理劳务人员
      {
        path: "managingStaff",
        name: "管理劳务人员",
        component: () =>
          import("@/views/salesCloud/usersSupervise/managingStaff/index"),
      },
      // 经营主体管理
      {
        path: "businessEntity",
        name: "经营主体管理",
        component: () => import("@/views/salesCloud/businessEntity/index"),
      },
      {
        path: "orderShopAgent",
        name: "订单系统商户管理",
        component: () =>
          import("@/views/salesCloud/usersSupervise/orderShopAgent/index"),
      },
      {
        path: "shopGoods",
        name: "店铺商品管理",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/shopGoods/index"),
      },
      {
        path: "walletDeposit",
        name: "提现审核控制",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/walletDeposit/index"),
      },
      {
        path: "scanRed",
        name: "红包管理",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/scanRed/index"),
      },
      {
        path: "scanRedDetails",
        name: "红包详情",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/scanRedDetails/index"),
      },
      {
        path: "license",
        name: "店铺资质管理",
        component: () =>
          import("@/views/salesCloud/usersSupervise/license/index"),
      },
      {
        path: "customerStatus",
        name: "客户状态管理",
        component: () =>
          import("@/views/salesCloud/customerSupervise/customerStatus/index"),
      },
      {
        path: "customerInfo",
        name: "客户信息管理",
        component: () =>
          import("@/views/salesCloud/customerSupervise/customerInfo/index"),
      },
      // 客户信息反馈（后台查询）
      {
        path: "ticketFeedback",
        name: "客户信息反馈",
        component: () =>
          import("@/views/salesCloud/customerSupervise/ticketFeedback/index"),
      },
      {
        path: "customerFile",
        name: "客户档案管理",
        component: () =>
          import("@/views/salesCloud/customerSupervise/customerFile/index"),
      },
      {
        path: "customerFile/add",
        name: "新增客户档案",
        component: () =>
          import("@/views/salesCloud/customerSupervise/customerFile/add"),
      },
      // 查看客户档案
      {
        path: "customerFile/view",
        name: "查看客户档案",
        component: () =>
          import("@/views/salesCloud/customerSupervise/customerFile/view"),
      },
      {
        path: "customerFile/edit",
        name: "编辑客户档案",
        component: () =>
          import("@/views/salesCloud/customerSupervise/customerFile/edit"),
      },

      {
        path: "paramConfig",
        name: "动态参数配置",
        component: () =>
          import("@/views/salesCloud/customerSupervise/paramConfig/index"),
      },
      {
        path: "purchaseOrder",
        name: "进货单管理",
        component: () =>
          import(
            "@/views/salesCloud/distributionSupervise/purchaseOrder/index"
          ),
      },
      {
        path: "supplyList",
        name: "供货单管理",
        component: () =>
          import("@/views/salesCloud/distributionSupervise/supplyList/index"),
      },
      {
        path: "distributionSheet",
        name: "配送单管理",
        component: () =>
          import(
            "@/views/salesCloud/distributionSupervise/distributionSheet/index"
          ),
      },
      {
        path: "returnOrder",
        name: "退货管理",
        component: () =>
          import("@/views/salesCloud/distributionSupervise/returnOrder/index"),
      },
      {
        path: "workOrder",
        name: "预约单管理",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/workOrder/index"),
      },
      {
        path: "workOrder/detail",
        name: "工单信息",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/workOrder/detail"),
      },
      {
        path: "redPacket",
        name: "红包管理",
        component: () => import("@/views/salesCloud/redPacket/index"),
      },
      {
        path: "goodsQr",
        name: "商品二维码管理",
        component: () => import("@/views/salesCloud/goodsQr/index"),
      },
      {
        path: "serviceHotline",
        name: "服务热线",
        component: () => import("@/views/salesCloud/serviceHotline/index"),
      },
      {
        path: "integralCoupon",
        name: "积分商城优惠券管理",
        component: () => import("@/views/salesCloud/integralCoupon/index"),
      },
      {
        path: "goodsQrDetails",
        name: "商品二维码详情",
        component: () =>
          import("@/views/salesCloud/goodsQr/goodsQrDetails/index"),
      },
      {
        path: "preFilter",
        name: "商品二维码审核管理",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/preFilter/index"),
      },
      {
        path: "balance",
        name: "客户账户余额管理",
        component: () =>
          import("@/views/salesCloud/financeSupervise/balance/index"),
      },
      {
        path: "bill",
        name: "客户对账单管理",
        component: () =>
          import("@/views/salesCloud/financeSupervise/bill/index"),
      },
      {
        path: "engineeringOrder",
        name: "工程单管理",
        component: () =>
          import(
            "@/views/salesCloud/marketingSupervise/engineeringOrder/index"
          ),
      },
      {
        path: "balanceDetails",
        name: "客户账户余额入账记录",
        component: () =>
          import("@/views/salesCloud/financeSupervise/balanceDetails/index"),
      },
      {
        path: "checkDetail",
        name: "客户账户进货对账单记录",
        component: () =>
          import("@/views/salesCloud/financeSupervise/checkDetail/index"),
      },
      {
        path: "productStatistics",
        name: "商品订单管理",
        component: () =>
          import(
            "@/views/salesCloud/commerceSupervise/productStatistics/index"
          ),
        meta: {
          keepAlive: true,
        },
      },
      {
        path: "productOrderDetailsMerchant",
        name: "产品订单明细(商家)",
        component: () =>
          import(
            "@/views/salesCloud/commerceSupervise/productOrderDetailsMerchant/index"
          ),
      },
      {
        path: "productOrderDetailsExpress",
        name: "产品订单管理",
        component: () =>
          import(
            "@/views/salesCloud/commerceSupervise/productOrderDetailsExpress/index"
          ),
          meta: {
            keepAlive: true,
          },
      },
      {
        path: "snapOrder",
        name: "抢购订单管理",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/snapOrder/index"),
      },
      {
        path: "rule",
        name: "等级升级规则管理",
        component: () => import("@/views/salesCloud/teamSupervise/rule/index"),
      },
      {
        path: "grade",
        name: "团队等级管理",
        component: () => import("@/views/salesCloud/teamSupervise/grade/index"),
      },
      {
        path: "exitRule",
        name: "脱离团队规则管理",
        component: () =>
          import("@/views/salesCloud/teamSupervise/exitRule/index"),
      },
      {
        path: "teamMessage",
        name: "团队消息管理",
        component: () =>
          import("@/views/salesCloud/teamSupervise/teamMessage/index"),
      },
      {
        path: "teamData",
        name: "团队数据管理",
        component: () =>
          import("@/views/salesCloud/teamSupervise/teamData/index"),
      },
      {
        path: "serviceCoupon",
        name: "服务优惠券管理",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/serviceCoupon/index"),
      },
      {
        path: "serviceCoupon/:id",
        name: "服务优惠券明细列表",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/serviceCoupon/detail"),
      },
      {
        path: "productGoods",
        name: "售卖产品管理",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/productGoods/index"),
      },
      {
        path: "accountBalance",
        name: "账户余额管理",
        component: () =>
          import("@/views/salesCloud/walletSupervise/accountBalance/index"),
      },
      {
        path: "integralBalance",
        name: "积分余额管理",
        component: () =>
          import("@/views/salesCloud/walletSupervise/integralBalance/index"),
      },
      {
        path: "manualIntegral",
        name: "积分明细管理",
        component: () =>
          import("@/views/salesCloud/walletSupervise/manualIntegral/index"),
      },
      {
        path: "bank",
        name: "银行卡管理",
        component: () =>
          import("@/views/salesCloud/walletSupervise/bank/index"),
      },
      {
        path: "accountDetails",
        name: "账号明细管理",
        component: () =>
          import("@/views/salesCloud/walletSupervise/accountDetails/index"),
      },
      {
        path: "depositRecharge",
        name: "押金充值管理",
        component: () =>
          import("@/views/salesCloud/depositSupervise/depositRecharge/index"),
      },
      {
        path: "depositRecord",
        name: "商户押金充值记录",
        component: () =>
          import("@/views/salesCloud/depositSupervise/depositRecord/index"),
      },
      {
        path: "unfreezeApply",
        name: "押金解冻申请管理",
        component: () =>
          import("@/views/salesCloud/depositSupervise/unfreezeApply/index"),
      },
      {
        path: "distributionArea",
        name: "商户配送区域管理",
        component: () =>
          import(
            "@/views/salesCloud/distributionSupervise/distributionArea/index"
          ),
      },
      {
        path: "shipment",
        name: "产品出货管理",
        component: () =>
          import("@/views/salesCloud/shipmentSupervise/shipment/index"),
      },
      {
        path: "shipment/add",
        name: "新增产品出货",
        component: () =>
          import("@/views/salesCloud/shipmentSupervise/shipment/add"),
      },
      {
        path: "shipmentCheck",
        name: "出货对账管理",
        component: () =>
          import("@/views/salesCloud/shipmentSupervise/shipmentCheck/index"),
      },
      {
        path: "shipmentProduct",
        name: "出货产品列表",
        component: () =>
          import("@/views/salesCloud/shipmentSupervise/shipmentProduct/index"),
      },
      {
        path: "shipmentEngineerProduct",
        name: "工程采购出货产品列表",
        component: () =>
          import(
            "@/views/salesCloud/shipmentSupervise/shipmentEngineerProduct/index"
          ),
      },
      {
        path: "shipmentProductDetail",
        name: "出货产品记录",
        component: () =>
          import(
            "@/views/salesCloud/shipmentSupervise/shipmentProductDetail/index"
          ),
      },
      {
        path: "tabulate",
        name: "经销商库存管理",
        component: () =>
          import("@/views/salesCloud/shipmentSupervise/tabulate/index"),
      },
      {
        path: "tabulateList",
        name: "库存列表",
        component: () =>
          import("@/views/salesCloud/shipmentSupervise/tabulateList/index"),
      },
      {
        path: "tabulateEngineerList",
        name: "工程采购库存列表",
        component: () =>
          import(
            "@/views/salesCloud/shipmentSupervise/tabulateEngineerList/index"
          ),
      },
      {
        path: "tabulateDetail",
        name: "产品库存详情",
        component: () =>
          import("@/views/salesCloud/shipmentSupervise/tabulateDetail/index"),
      },
      {
        path: "success",
        name: "支付成功页面",
        component: () => import("@/views/salesCloud/payPage/success"),
      },
      {
        path: "pay",
        name: "支付页面",
        component: () => import("@/views/salesCloud/payPage/pay"),
      },
      {
        path: "productCoupon",
        name: "商品优惠券",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/productCoupon/index"),
      },
      {
        path: "productCouponDetail",
        name: "商品优惠券明细",
        component: () =>
          import(
            "@/views/salesCloud/marketingSupervise/productCouponDetail/index"
          ),
      },
      {
        path: "couponRule",
        name: "优惠券获取规则",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/couponRule/index"),
      },
      {
        path: "messageTip",
        name: "消息提醒管理",
        component: () =>
          import("@/views/salesCloud/customerSupervise/messageTip/index"),
      },
      {
        path: "messageTipModule",
        name: "消息提醒模板管理",
        component: () =>
          import("@/views/salesCloud/customerSupervise/messageTipModule/index"),
      },
      {
        path: "messageTipModule/add",
        name: "新增消息提醒模板",
        component: () =>
          import("@/views/salesCloud/customerSupervise/messageTipModule/add"),
      },
      {
        path: "customerInfo/add",
        name: "新增客户信息",
        component: () =>
          import("@/views/salesCloud/customerSupervise/customerInfo/add"),
      },
      {
        path: "customerInfo/edit",
        name: "编辑客户信息",
        component: () =>
          import("@/views/salesCloud/customerSupervise/customerInfo/edit"),
      },
      {
        path: "customerInfo/view",
        name: "查看客户信息",
        component: () =>
          import("@/views/salesCloud/customerSupervise/customerInfo/view"),
      },
      {
        path: "messageLogo",
        name: "消息发送记录",
        component: () =>
          import("@/views/salesCloud/customerSupervise/messageLogo/index"),
      },
      {
        path: "snapGoods",
        name: "抢购商品管理",
        component: () =>
          import("@/views/salesCloud/marketingSupervise/snapGoods/index"),
      },
      {
        path: "ceiling",
        name: "钱包金额权限设置",
        component: () =>
          import("@/views/salesCloud/walletSupervise/ceiling/index"),
      },
      {
        path: "accountGroup",
        name: "工程师分组",
        component: () => import("@/views/salesCloud/accountGroup/index"),
      },
      {
        path: "accountGroup/roster",
        name: "工程师花名册管理",
        component: () => import("@/views/salesCloud/accountGroup/roster/index"),
      },
      {
        path: "hvacPackage",
        name: "暖通套餐",
        component: () => import("@/views/salesCloud/hvacPackage/index"),
      },
      {
        path: "hvacPackage/code",
        name: "暖通二维码",
        component: () => import("@/views/salesCloud/hvacPackage/code"),
      },
      {
        path: "protocolManagement",
        name: "协议文档管理",
        component: () =>
          import("@/views/salesCloud/protocolManagement/index"),
      },
      {
        path: "safetyGuardAgent",
        name: "安全卫士代理商管理",
        component: () =>
          import("@/views/salesCloud/safetyGuard/agent/index"),
      },
      {
        path: "safetyBlacklist",
        name: "报单黑名单管理",
        component: () =>
          import("@/views/salesCloud/safetyGuard/blacklist/index"),
      },
      {
        path: "afterSale",
        name: "防水售后单管理",
        component: () =>
          import("@/views/salesCloud/afterSale/index"),
        meta: {
            keepAlive: true,
        }
      },
    ],
  },
];
